"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAbTestCookie = exports.getSession = exports.getAbTestCookie = exports.getAdId = void 0;
var Cookies = __importStar(require("js-cookie"));
var ABTEST_COOKIE = 'abtest';
var ABTEST_COOKIE_DOMAIN = 'finn.no';
var inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
var defaultCookieConfig = {
    domain: ABTEST_COOKIE_DOMAIN,
    expires: inThirtyMinutes,
};
var currentTime = function () { return Math.round(Date.now() / 1000); };
function getAdId() {
    var cookie = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent('_pulse2data').replace(/[-.+*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1')) || false;
    if (cookie) {
        return cookie.split(',')[9];
    }
    return;
}
exports.getAdId = getAdId;
function getAbTestCookie() {
    var abTestCookie = Cookies.get(ABTEST_COOKIE);
    var activeAbTests = '';
    if (abTestCookie) {
        try {
            activeAbTests = Object.keys(JSON.parse(abTestCookie)).join(',');
        }
        catch (e) {
            if (window.trackJs) {
                window.trackJs.track("abtest cookie: " + abTestCookie);
            }
        }
    }
    return activeAbTests;
}
exports.getAbTestCookie = getAbTestCookie;
function getSession() {
    var session = Cookies.get('SESSION');
    return session;
}
exports.getSession = getSession;
var horsehoeAbTestFeatures = function (features) { return features === null || features === void 0 ? void 0 : features.filter(function (i) { return i.abtest; }).reduce(function (acc, cur) {
    acc[cur.id] = currentTime();
    return acc;
}, {}); };
var filterExistingAbTests = function (horseshoeFeatures, existingFeatures) {
    var existingTests = existingFeatures.split(',');
    return horseshoeFeatures.filter(function (i) { return i.enabled && i.abtest && !existingTests.includes(i.id); });
};
function setAbTestCookie(featureSet) {
    //js-cookie will not encode curly braces out of the box so custom encoder is required
    var cookiesWithConverter = Cookies.withConverter({
        write: function (value, _name) {
            return encodeURIComponent(value);
        },
    });
    var abTests = getAbTestCookie();
    // check that current cookie and filter out existing Horseshoe Features
    var filteredFeatures = filterExistingAbTests(featureSet, abTests);
    // create abTest cookie entries for features in this repo
    var values = horsehoeAbTestFeatures(filteredFeatures);
    if (filteredFeatures.length > 0) {
        if (abTests) {
            try {
                // if the cookie exists, then re-write it augmented with new entries from horseshoe features
                var originalCookie = decodeURIComponent(Cookies.get(ABTEST_COOKIE));
                var originalCookieAsJSON = JSON.parse(originalCookie);
                var augementedCookie = __assign(__assign({}, originalCookieAsJSON), values);
                // delete the original cookie
                Cookies.remove(ABTEST_COOKIE);
                //create a new cookie
                cookiesWithConverter.set(ABTEST_COOKIE, augementedCookie, defaultCookieConfig);
            }
            catch (e) {
                console.error("Error while parsing existing abtest cookie " + e);
            }
        }
        else {
            cookiesWithConverter.set(ABTEST_COOKIE, values, defaultCookieConfig);
        }
    }
}
exports.setAbTestCookie = setAbTestCookie;
